import moment from "moment";

export interface IQRCode {
	CodeBase64?: string;
	ExpiredSeconds: number;
	QRCodeUrl: string;
	ExpiredTimestamp?: number;
	ExpiredAt?: string;
	checkExpired?: () => boolean;
}

export class QrCode implements IQRCode{
	CodeBase64?: string;
	ExpiredSeconds: number;
	QRCodeUrl: string;
	ExpiredAt?: string;
	ExpiredTimestamp?: number;
	
	constructor(props: IQRCode) {
		this.CodeBase64 = props.CodeBase64 || '';
		this.ExpiredSeconds = props.ExpiredSeconds || 0;
		this.QRCodeUrl = props.QRCodeUrl || '';
		this.setSeconds();
	}
	
	setSeconds() {
		let currentDate = moment();
		currentDate.add((this.ExpiredSeconds || 0), 's');
		this.ExpiredAt = currentDate.format('LLLL');
		this.ExpiredTimestamp = currentDate.unix();
		
	}
	
	checkExpired() {
		return this.ExpiredTimestamp < moment().unix();
	}
}